var map = {
	"./de.json": [
		"bac1",
		"lang-de-json"
	],
	"./en.json": [
		"e312"
	],
	"./es.json": [
		"ef52",
		"lang-es-json"
	],
	"./fr.json": [
		"b16e",
		"lang-fr-json"
	],
	"./pt.json": [
		"de6e",
		"lang-pt-json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "f2d3";
module.exports = webpackAsyncContext;